import React, {useEffect, useRef, useState} from "react";
import {TieredMenu} from 'primereact/tieredmenu';
import {CategoryService} from "../../service/CategoryService";
import {useNavigate} from "react-router-dom";
import {Button} from 'primereact/button';

const Menu = (props) => {
    const [menu, setMenu] = useState([]);

    const refMenu = useRef(null);
    const navigate = useNavigate();

    const service = new CategoryService();

    useEffect(() => {
        service.findAll().then(response => {
            setMenu(response?.map(category => {
                    return {
                        label: category.title,
                        items: category.subcategoryList?.map(subcategory => ({
                            label: subcategory.title,
                            items: subcategory.labelList?.map(label => ({
                                label: label.title,
                                command: (e) => {
                                    refMenu.current.hide(e);
                                    navigate(`/courses/${category.id}/${subcategory.id}/${label.id}`);
                                }
                            })),
                            command: (e) => {
                                refMenu.current.hide(e);
                                navigate(`/courses/${category.id}/${subcategory.id}`);
                            }
                        })),
                        command: (e) => {
                            refMenu.current.hide(e);
                            navigate(`/courses/${category.id}`);
                        }
                    }
                })
            );
        });
    }, []);


    return (
        <Button label="Kategoriler" icon="pi pi-bars" text
                onMouseEnter={(e) => refMenu.current.show(e)}
                onMouseLeave={(e) => refMenu.current.hide(e)}
                size="small" >
            <TieredMenu model={menu} breakpoint="767px" popup ref={refMenu}/>
        </Button>
    );
}

export default Menu;
